import * as React from "react";
import {option, Option} from "ts-option";
import AssetSpecification from "../../../../model/asset/AssetSpecification";
import Input from "../../../../hiberUiKit/src/atoms/Input/Input";

interface IProps {
	/**
	 * Item asset to edit
	 */
	item: AssetSpecification;
	/**
	 * On asset value change callback.
	 * @param value
	 */
	onChange: (value: Option<string>) => void;
}

export default class AssetSpecificationTextSelector extends React.Component<IProps, {}> {
	render() {
		return (
			<div className={"c-assets-text"}>
				<div className={"c-assets-text_title"}>
					{this.props.item.label} :
				</div>
				<div className={"c-assets-text_value"}>
					<Input type={"text"}
						   onChange={(evt) => { this.props.onChange(option(evt.target.value))}}
						   value={this.props.item.value}/>
				</div>
			</div>
		);
	}
}